import { render, staticRenderFns } from "./ContactPreview.vue?vue&type=template&id=27da3fe3&scoped=true"
import script from "./ContactPreview.vue?vue&type=script&lang=js"
export * from "./ContactPreview.vue?vue&type=script&lang=js"
import style0 from "./ContactPreview.vue?vue&type=style&index=0&id=27da3fe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da3fe3",
  null
  
)

export default component.exports